export default {
  section: {
    p: {
      xs: '0px 0px 40px !important',
      xl: '0px 20px 40px 98px !important',
    },
  },
  contentWrapper: (theme) => ({
    display: 'flex',
    gap: 3,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 3,
    },
  }),
  rightLink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    marginBottom: {
      md: '0',
    },
  },
};
